import { render } from "./Total.vue?vue&type=template&id=0f6166c6&scoped=true"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"

import "./Total.vue?vue&type=style&index=0&id=0f6166c6&scoped=true&lang=css"

import exportComponent from "/var/www/ca-quiz.staging.mindoza.net/releases/20240705152708/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6166c6"]])

export default __exports__